/**
 * Responsive embeds
 *
 * Vanilla-JS replacement for the old jQuery FitVids plugin. Ghost wraps modern
 * embed cards in `.kg-embed-card` and styles them itself (card assets), so this
 * only takes care of bare <iframe>/<object>/<embed>/<video> elements that come
 * from older posts or from raw HTML cards.
 */

(function () {
    var selectors = [
        'iframe[src*="youtube.com"]',
        'iframe[src*="youtube-nocookie.com"]',
        'iframe[src*="youtu.be"]',
        'iframe[src*="vimeo.com"]',
        'iframe[src*="dailymotion.com"]',
        'iframe[src*="player.twitch.tv"]',
        'object',
        'embed'
    ];

    function ratioOf(element) {
        var width = parseInt(element.getAttribute('width'), 10);
        var height = parseInt(element.getAttribute('height'), 10);

        if (width && height) {
            return height / width;
        }

        return 9 / 16;
    }

    function makeResponsive(element) {
        // already wrapped, or handled by Ghost's own card styles
        if (element.closest('.fluid-width-video-wrapper, .kg-embed-card, .kg-video-card, .kg-audio-card')) {
            return;
        }

        var wrapper = document.createElement('div');
        wrapper.className = 'fluid-width-video-wrapper';
        wrapper.style.paddingTop = (ratioOf(element) * 100) + '%';

        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);

        element.removeAttribute('width');
        element.removeAttribute('height');
    }

    function init() {
        var containers = document.querySelectorAll('.post-full-content, .post-content');

        Array.prototype.forEach.call(containers, function (container) {
            var embeds = container.querySelectorAll(selectors.join(', '));
            Array.prototype.forEach.call(embeds, makeResponsive);
        });
    }

    if (document.readyState !== 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
})();
